var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgPeopleAlt = function SvgPeopleAlt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 40 40",
    fill: "currentColor"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h40v40H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.783 21.883c2.284 1.55 3.884 3.65 3.884 6.45v5h6.666v-5c0-3.633-5.95-5.783-10.55-6.45zM25 20a6.665 6.665 0 006.667-6.667A6.665 6.665 0 0025 6.667c-.783 0-1.517.166-2.217.4a9.966 9.966 0 010 12.533c.7.233 1.434.4 2.217.4zm-10 0a6.665 6.665 0 006.667-6.667A6.665 6.665 0 0015 6.667a6.665 6.665 0 00-6.667 6.666A6.665 6.665 0 0015 20zm0-10c1.833 0 3.333 1.5 3.333 3.333 0 1.834-1.5 3.334-3.333 3.334a3.343 3.343 0 01-3.333-3.334C11.667 11.5 13.167 10 15 10zm0 11.667c-4.45 0-13.333 2.233-13.333 6.666v5h26.666v-5c0-4.433-8.883-6.666-13.333-6.666zM25 30H5v-1.65c.333-1.2 5.5-3.35 10-3.35s9.667 2.15 10 3.333V30z",
    fill: "#EEE",
    fillRule: "nonzero"
  }))));
};
export default SvgPeopleAlt;